import { c as _c } from "react/compiler-runtime";
import { Box, styled, Tooltip, type SxProps, type Theme } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';
import { CloudProviders } from '@/data/inventory/data';
import type { BackupVault } from '@/data/vaults/backupVault';
import { useBackupVaults } from '@/data/vaults/useBackupVaults';
import { NativeVaultColor } from '@/theme/colorSchemes';
import { BackupVaultCard, VaultCardAsAccount } from './backupVaultCard';
const Tag = styled('div')((props: {
  backgroundColor: string;
  additionalStyles?: object;
}) => ({
  cursor: 'default',
  borderRadius: '4px',
  fontSize: '12px',
  padding: '2px 8px',
  margin: '2px 4px',
  color: 'black',
  backgroundColor: props.backgroundColor,
  display: 'inline-block',
  ...props.additionalStyles
}));
function VaultTagFromId(t0) {
  const $ = _c(8);
  const {
    vaultId,
    showCard
  } = t0;
  const {
    vaults
  } = useBackupVaults();
  let t1;
  if ($[0] !== vaultId || $[1] !== vaults) {
    let t2;
    if ($[3] !== vaultId) {
      t2 = vault => vault.id === vaultId;
      $[3] = vaultId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = vaults.find(t2);
    $[0] = vaultId;
    $[1] = vaults;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const vault_0 = t1;
  if (!vault_0) {
    return null;
  }
  let t2;
  if ($[5] !== showCard || $[6] !== vault_0) {
    t2 = <VaultTag vault={vault_0} showCard={showCard} />;
    $[5] = showCard;
    $[6] = vault_0;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function VaultTag(t0) {
  const $ = _c(7);
  const {
    sx,
    vault,
    showCard: t1
  } = t0;
  const showCard = t1 === undefined ? true : t1;
  if (typeof vault === "string") {
    let t2;
    if ($[0] !== showCard || $[1] !== vault) {
      t2 = <VaultTagFromId vaultId={vault} showCard={showCard} />;
      $[0] = showCard;
      $[1] = vault;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== showCard || $[4] !== sx || $[5] !== vault) {
    t2 = <BackupVaultTag sx={sx} vault={vault} showCard={showCard} />;
    $[3] = showCard;
    $[4] = sx;
    $[5] = vault;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export const AccountAsVaultTag = t0 => {
  const $ = _c(9);
  const {
    sx,
    cloudProvider,
    region
  } = t0;
  const accountLabel = cloudProvider === Provider.Azure ? "subscription" : cloudProvider === Provider.Gcp ? "project" : "account";
  const t1 = `Source ${accountLabel}`;
  let t2;
  if ($[0] !== cloudProvider || $[1] !== region || $[2] !== sx) {
    t2 = <VaultCardAsAccount sx={sx} cloudProvider={cloudProvider} region={region} />;
    $[0] = cloudProvider;
    $[1] = region;
    $[2] = sx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== cloudProvider || $[5] !== sx || $[6] !== t1 || $[7] !== t2) {
    t3 = <VaultTagInner sx={sx} backgroundColor={NativeVaultColor} name={t1} cloudProvider={cloudProvider} vaultCard={t2} />;
    $[4] = cloudProvider;
    $[5] = sx;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const BackupVaultTag = t0 => {
  const $ = _c(9);
  const {
    sx,
    vault,
    showCard
  } = t0;
  const t1 = vault.backgroundColor || "black";
  let t2;
  if ($[0] !== showCard || $[1] !== vault) {
    t2 = showCard ? <BackupVaultCard data={vault} editable={false} /> : null;
    $[0] = showCard;
    $[1] = vault;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== sx || $[4] !== t1 || $[5] !== t2 || $[6] !== vault.name || $[7] !== vault.vaultAttributes.cloudProvider) {
    t3 = <VaultTagInner sx={sx} backgroundColor={t1} name={vault.name} cloudProvider={vault.vaultAttributes.cloudProvider} vaultCard={t2} />;
    $[3] = sx;
    $[4] = t1;
    $[5] = t2;
    $[6] = vault.name;
    $[7] = vault.vaultAttributes.cloudProvider;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const VaultTagInner = t0 => {
  const $ = _c(16);
  const {
    sx,
    backgroundColor,
    name,
    cloudProvider,
    vaultCard
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = {
      ...sx,
      maxWidth: "140px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = backgroundColor || "black";
  const t3 = CloudProviders[cloudProvider]?.displayName;
  let t4;
  if ($[2] !== t3) {
    t4 = <Box component="span" className="font-semibold mr-[4px]">{t3}</Box>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== name) {
    t5 = <Box component="span">{name}</Box>;
    $[4] = name;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <Tag data-testid="vault-tag" additionalStyles={t1} backgroundColor={t2}>{t4}{t5}</Tag>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const tag = t6;
  if (!vaultCard) {
    return tag;
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      name: "preventOverflow",
      options: {
        boundary: "viewport",
        altAxis: true,
        padding: 8
      }
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      popper: {
        modifiers: [t7, {
          name: "flip",
          options: {
            fallbackPlacements: ["top", "bottom", "left", "right"]
          }
        }]
      },
      tooltip: {
        sx: {
          padding: 0,
          backgroundColor: "transparent",
          maxWidth: "300px"
        }
      }
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== tag || $[14] !== vaultCard) {
    t9 = <Tooltip disableInteractive={false} disableFocusListener={true} slotProps={t8} title={vaultCard}>{tag}</Tooltip>;
    $[13] = tag;
    $[14] = vaultCard;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};